"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var BASE_URL = "/email/v1/optin/portals/" + _hubspot.default.get() + "/settings";

var DoiSettingsAPI =
/*#__PURE__*/
function () {
  function DoiSettingsAPI() {
    (0, _classCallCheck2.default)(this, DoiSettingsAPI);
  }

  (0, _createClass2.default)(DoiSettingsAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(BASE_URL);
    }
  }, {
    key: "update",
    value: function update(doiSettings) {
      return _apiClient.default.put(BASE_URL, {
        data: doiSettings
      });
    }
  }]);
  return DoiSettingsAPI;
}();

exports.default = DoiSettingsAPI;
module.exports = exports.default;